import React, { useEffect, useState } from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';
import { useGridApiRef } from '@mui/x-data-grid-premium';

import { AutoCompleteSelectUI, DataGridIdentifiers, DatagridPremiumUi } from '../../../Interface';
import dynamicFormService from '../../../../service/dynamicForm.service';

const WorksheetReport = () => {
  const apiRef = useGridApiRef();
  const [worksheetOptions, setWorksheetOptions] = useState([]);
  const [selectedWorksheetId, setSelectedWorksheetId] = useState(null);
  const [report, setReport] = useState({ columns: [], rows: [] });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dynamicFormService.getWorksheetReportForms().then((data) => {
      setWorksheetOptions(
        (data || []).map((worksheet) => ({
          label: worksheet.name,
          value: worksheet.id,
        }))
      );
    });
  }, []);

  const handleWorksheetChange = (_event, selectedOption) => {
    const worksheetId = selectedOption?.value ?? null;
    setSelectedWorksheetId(worksheetId);
    setReport({ columns: [], rows: [] });

    if (!worksheetId) return;

    setLoading(true);
    dynamicFormService
      .getWorksheetReport(worksheetId)
      .then((data) => {
        setReport({
          columns: data?.columns || [],
          rows: data?.rows || [],
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Container maxWidth={false} sx={{ py: 2 }}>
      <Typography variant="h5" mb={2}>
        Munkalapok
      </Typography>

      <Paper elevation={1} sx={{ p: 2 }}>
        <Box maxWidth={500} mb={2}>
          <AutoCompleteSelectUI
            label="Munkalap fajtája"
            options={worksheetOptions}
            value={worksheetOptions.find((option) => option.value === selectedWorksheetId) || null}
            onChange={handleWorksheetChange}
            placeholder="Válassz munkalapfajtát"
          />
        </Box>

        <Box sx={{ height: 'calc(100vh - 210px)', minHeight: 400, width: '100%' }}>
          <DatagridPremiumUi
            apiRef={apiRef}
            datagridIdentifier={DataGridIdentifiers.WorksheetReport}
            rows={report.rows}
            columns={report.columns}
            loading={loading}
            pagination={false}
            paginationAndfilterMode="client"
            disableSave
            height="100%"
            hideFooter
            headerFilters={false}
            getRowHeight={() => 'auto'}
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default WorksheetReport;
